/* eslint-disable prettier/prettier */
import React, { Fragment } from 'react';
import { Overlay, OverlayTrigger, Tooltip, Popover, Form, Button, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle, faPlus } from '@fortawesome/free-solid-svg-icons'
import * as Logger from 'loglevel';
import DateTimePicker from 'react-datetime-picker';

import * as EditorConstant from './util/EditorConstant';
import Utilitis, { UtilConstant } from 'hub-utilities';
import { Typeahead } from 'react-bootstrap-typeahead'

import './styles.module.scss'
import 'react-bootstrap-typeahead/css/Typeahead.css';

const IButtonType = {
    BootstrapButton: 0,
    faEditorToggler: 1,
    faToggleIconProp: 2
};

export class DataEditor extends React.PureComponent {

    constructor(props) {
        super(props);
        this.overlayRef = React.createRef();
        this.state = {
            fieldVals: [],
            mediaCount: 0, //There can only be 1 media as of now
            fileName: "",
            formStatus: "",
            formError: "", //was fileUploadStatus
            isStatusEnabled: false,
            uploading: false,
            attachments: [],
            target: null,
            hasError: false
        };
    }

    componentWillMount() {
        if (this.areDataEditorPropsFullyInitialized())
            this.initializeFieldVals();
    }

    componentDidMount() {
        //for outside clicks:
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        //for outside clicks:
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (!!this.props.isAddRow && this.props.isActive) {
            if (!!this.overlayRef && !!this.overlayRef.current && !this.overlayRef.current.contains(event.target)) {
                this.props.onToggle(Math.abs(this.props.id));
            }
        }
    }

    // Warning: Can't call setState on a component that is not yet mounted
    initializeFieldVals() {
        var fieldStates = [];
        for (let i = 0; i < this.props.mediaEditInfo.length; i++) {
            if (this.props.mediaEditInfo[i].dataType === undefined) Logger.error(`Undefined dataType for: ${this.props.title}.`)
            switch (this.props.mediaEditInfo[i].type) {
                case EditorConstant.DataEditorType.TEXT_FIELD:
                case EditorConstant.DataEditorType.SUGGESTION_BOX:
                    fieldStates.push(!!this.props.initialVal ? this.props.initialVal : "");
                    break;
                case EditorConstant.DataEditorType.TEXT_AREA:
                    fieldStates.push(!!this.props.initialVal ? this.props.initialVal : "");
                    break;
                case EditorConstant.DataEditorType.BROWSE_MEDIA:
                    fieldStates.push("");
                    break;
                case EditorConstant.DataEditorType.DATE_TIME_FIELD:
                    fieldStates.push(!!this.props.initialVal ? new Date(this.props.initialVal + ".000Z") : new Date());
                    break;
                case EditorConstant.DataEditorType.DROP_DOWN:
                    fieldStates.push("");
                    break;
                default:
                    break;
            }
        }
        this.setState({
            fieldVals: fieldStates
        });
    }

    componentWillReceiveProps(newProps) {
        //edge case scenario: if the table is empty + changees the datatype while adding data (esp from text to date), the page prob crashes due to datepicker

        var shouldFlushVals = false;

        if ((!!this.props.mediaEditInfo && this.props.mediaEditInfo.length > 0 && !!this.props.isAddRow)) {
            //Logger.debug("REFRESHED");
            var shouldFlushVals = false;
            for (var i = 0; i < this.props.mediaEditInfo.length; i++) {
                if (!!newProps.mediaEditInfo[i]) {
                    if (this.props.mediaEditInfo[i].dataType !== newProps.mediaEditInfo[i].dataType) {
                        shouldFlushVals = true;
                    }
                }
            }
        }

        if (newProps.initialVal !== this.props.initialVal) shouldFlushVals = true;

        //flush vals:
        if (shouldFlushVals) {
            this.props.onToggle(Math.abs(this.props.id), true);
            var emptiedFieldVals = this.state.fieldVals;
            for (var i = 0; i < emptiedFieldVals.length; i++) {
                emptiedFieldVals[i] = "";
            }
            this.setState({ fieldVals: emptiedFieldVals }, () => this.initializeFieldVals())
        };
    }

    setFieldVal = (index, val) => {
        var newFieldVals = [];
        newFieldVals = newFieldVals.concat(this.state.fieldVals);
        newFieldVals[index] = val;
        this.setState({
            fieldVals: newFieldVals
        })
    }

    fileUploadHandler = async (event) => {
        if (!!this.props.authService && !!event.target) {
            var target = event.target;
            Logger.debug(`Uploading file ${target.value} started`);
            let selectedFilename = Utilitis.getFileNameFromPath(event.target.value);
            this.setState({ fileName: selectedFilename, formStatus: "", uploading: true });
            let formData = new FormData();
            if (!!target
                && !!target.files
                && !!target.files[0]) {
                formData.append("file", target.files[0]);
            }
            let token = await this.props.authService.getAccessTokenAsync();
            const response = await fetch(`/api/CloudQ/1/file`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                body: formData
            });
            Logger.debug('fileUploadHandler response = ', response);
            this.setState({ uploading: false });
            let respObject = await response.json();
            let newSts;
            if (response.ok) {

                let elementId = respObject.hubObject.id;
                Logger.debug(`new media element ${elementId} created.`);
                let existingAttachments = (!!this.state.attachments) ? this.state.attachments : [];
                newSts = ({
                    ... this.state,
                    formError: "",
                    attachments: existingAttachments.concat({ elementId: elementId, fileName: selectedFilename }),
                    fileName: ""
                });
            }
            else {
                newSts = ({
                    ... this.state,
                    formError: `Uploading ${selectedFilename} failed: ${respObject.error}.`,
                    hasError: false,
                    fileName: ""
                });
            }
            this.setState(newSts);
        } else {
            console.error("You need this.props.authService to user file uploader!")
        }
    };

    renderFields() {
        var fieldsToRender = [];
        let uploadedAttachments = <div></div>;
        if (!!this.state.attachments && this.state.attachments.length > 0) {
            let fileList = this.state.attachments.map((a) => { return <div key={a.elementId}>{a.fileName}</div> });
            uploadedAttachments = <div style={{ textAlign: "center" }}>Uploaded{" "}{fileList}</div>;
        }
        for (let i = 0; i < this.state.fieldVals.length; i++) {
            if (!!this.props.mediaEditInfo[i]) {
                switch (this.props.mediaEditInfo[i].type) {
                    case EditorConstant.DataEditorType.TEXT_FIELD:
                        fieldsToRender.push(
                            <Form.Control
                                key={i}
                                autoFocus
                                name={i.toString()}
                                type={this.props.mediaEditInfo[i].dataType === UtilConstant.HUB_DATA_TYPE.DECIMAL ? "number" : "text"}
                                className="rowEditorTextField"
                                placeholder={this.props.mediaEditInfo[i].placeholder}
                                value={this.state.fieldVals[i]}
                                onChange={e => this.setFieldVal(parseInt(e.target.name), e.target.value)} />);
                        break;
                    case EditorConstant.DataEditorType.TEXT_AREA:
                        fieldsToRender.push(
                            <Form.Control
                                as="textarea"
                                rows={3}
                                key={i}
                                name={i.toString()}
                                type={this.props.mediaEditInfo[i].dataType === UtilConstant.HUB_DATA_TYPE.DECIMAL ? "number" : "text"}
                                className="rowEditorTextArea"
                                placeholder={this.props.mediaEditInfo[i].placeholder}
                                value={this.state.fieldVals[i]}
                                onChange={e => this.setFieldVal(parseInt(e.target.name), e.target.value)} />);

                        break;
                    case EditorConstant.DataEditorType.BROWSE_MEDIA:
                        fieldsToRender.push(
                            <div key={`browse_media${i}`} >
                                <div className="input-group">
                                    {/* <div className="input-group-prepend"> {uploadPrepend}</div> */}
                                    <div className="custom-file">
                                        <input
                                            type="file"
                                            onChange={(event) => this.fileUploadHandler(event)}
                                            className="custom-file-input rowEditorMediaBrowser"
                                            id="inputGroupFile01"
                                            aria-describedby="inputGroupFileAddon01" />
                                        <label className="custom-file-label" htmlFor="inputGroupFile01">{this.state.fileName ? this.state.fileName : "Add Media"}</label>
                                    </div>
                                </div>
                                <div className="uploadedFileDisplay">
                                    {uploadedAttachments}
                                </div>
                            </div>
                        )
                        break;
                    case EditorConstant.DataEditorType.DROP_DOWN:
                        if (this.props.mediaEditInfo[i].dropdownVals == null || this.props.mediaEditInfo[i].dropdownVals === undefined
                            || this.props.mediaEditInfo[i].dropdownValKey == null || this.props.mediaEditInfo[i].dropdownValKey === undefined) {
                            Logger.error("You've declared the DataEditorType to be DROP_DOWN, please add dropdownVals and dropdownValKey to mediaEditInfo.");
                            fieldsToRender.push(
                                <div
                                    key={`dataEditor_dropdown_error${i}`}
                                    style={{ color: "red", background: "rgba(255,255,255,0.6)" }}
                                >
                                    Error: You've declared the DataEditorType to be DROP_DOWN, please add dropdownVals and dropdownValKey to mediaEditInfo.
                                </div>);
                            break;
                        }
                        var dropdownValKey = this.props.mediaEditInfo[i].dropdownValKey
                        var dropdownVals = this.props.mediaEditInfo[i].dropdownVals;
                        fieldsToRender.push(
                            <Dropdown key={`dataEditor_dropdown${i}`} className="formDropdown">
                                <Dropdown.Toggle id="dropdown-basic2">
                                    {!!this.state.fieldVals[i] && !!dropdownValKey ?
                                        this.props.mediaEditInfo[0].dataType === UtilConstant.HUB_DATA_TYPE.DATETIME ?
                                            Utilitis.formatObjectDate((this.state.fieldVals[i][dropdownValKey]).toString() + ".000Z", UtilConstant.HUB_TIME_FORMAT.CANADIAN, true, false, false) :
                                            this.state.fieldVals[i][dropdownValKey]
                                        : "Click to Select..."}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item key={"emptyFieldVal"} onClick={() => {
                                        //have to assign new state to new var, or else it glitches
                                        var newFieldVals = []
                                        newFieldVals = newFieldVals.concat(this.state.fieldVals);
                                        newFieldVals[i] = "";
                                        this.setState({ fieldVals: newFieldVals });
                                    }}>&nbsp;</Dropdown.Item>

                                    {dropdownVals.map((valObj) =>
                                        <Dropdown.Item key={valObj.index} onClick={() => {
                                            //have to assign new state to new var, or else it glitches
                                            var newFieldVals = []
                                            newFieldVals = newFieldVals.concat(this.state.fieldVals);
                                            newFieldVals[i] = valObj;
                                            this.setState({ fieldVals: newFieldVals });
                                        }}>{
                                                this.props.mediaEditInfo[0].dataType === UtilConstant.HUB_DATA_TYPE.DATETIME && !!dropdownValKey ?
                                                    Utilitis.formatObjectDate((valObj[dropdownValKey]).toString() + ".000Z", UtilConstant.HUB_TIME_FORMAT.CANADIAN, true, false, false) :
                                                    valObj[dropdownValKey]
                                            }</Dropdown.Item>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>
                        )
                        break;
                    case EditorConstant.DataEditorType.DATE_TIME_FIELD:
                        if (!!this.state.fieldVals[i]) {
                            fieldsToRender.push(
                                <DateTimePicker
                                    key={this.props.id}
                                    onChange={(e) => {
                                        var newFieldVals = [];
                                        newFieldVals = newFieldVals.concat(this.state.fieldVals);
                                        newFieldVals[i] = e;
                                        this.setState({ fieldVals: newFieldVals });
                                    }}
                                    value={this.state.fieldVals[i]}
                                    format="MMMdd, yyyy hh:mma"
                                    clearIcon={null}
                                    disableClock />
                            )
                        }
                        break;
                    case EditorConstant.DataEditorType.SUGGESTION_BOX:
                        Logger.debug("fieldVals:");
                        Logger.debug(this.state.fieldVals);
                        Logger.debug("mediaEditInfo:");
                        Logger.debug(this.props.mediaEditInfo);
                        if (!!this.props.mediaEditInfo[i].suggestions) {
                            fieldsToRender.push(
                                <Fragment
                                    key={`typeahead${this.props.id}`}>
                                    <Typeahead
                                        id={this.props.id}
                                        defaultInputValue={!!this.props.initialVal ? this.props.initialVal : ""}
                                        onInputChange={(input) => {
                                            // Handle selections...
                                            this.setFieldVal(i, input)
                                        }}
                                        onChange={(selected) => {
                                            // Handle selections...
                                            if (!!selected && selected.length > 0)
                                                this.setFieldVal(i, selected[0])
                                        }}

                                        options={this.props.mediaEditInfo[i].suggestions}
                                        placeholder={this.props.mediaEditInfo[i].placeholder}
                                    />
                                </Fragment>
                            )
                        } else {
                            console.error("this.props.mediaEditInfo[i].suggestions is missing from DataEditor - SUGGESTION_BOX.  Add it to render SUGGESTION_BOX properly")
                        }
                        break;
                    default:
                        break;
                }
            } else {
                Logger.error("Not every field in rowEditor satisfies as TEXT_FIELD, TEXT_AREA or BROWSE_MEDIA, please implement one yourself")
            }
        }
        return fieldsToRender;
    }

    renderTooltipText() {
        if (this.props.isRightDataType != null && this.props.isRightDataType !== undefined && !this.props.isRightDataType) {
            return (
                !!this.props.isAddRow ? `Data Type Mismatch\nFound in Vocabularies\nPlease Select Correct \nDataType via Dropdown\n Before Adding` : `Wrong Data Type \n Please Fix via \n DataType Dropdown`
            )
        } else if (this.props.mediaEditInfo[0].validateType === EditorConstant.DataValidationType.URL && !this.isValidURL(this.state.fieldVals[0].toString()) && !!this.props.disablePopup) {
            return "Invalid URL"
        } else {
            return this.props.title;
        }
    }

    areDataEditorPropsFullyInitialized() {
        var requiredKeys = ["id", "title", "toggleIcon", "mediaEditInfo", "isActive", "initialVal", "onToggle", "onSubmit"];

        var areMissingPropsDetected = false;
        for (let i = 0; i < requiredKeys.length; i++) {
            if (this.props[requiredKeys[i]] === undefined) {
                Logger.error(`The prop ${requiredKeys[i]} is missing.  Please add them to ensure that DataEditor is built correctly`);
                areMissingPropsDetected = true;
            }
        }
        return !areMissingPropsDetected;
    }

    onClickEditorToggle = (e) => {
        //this.props.editMetadata(); //reset error msg TODO: Need to solve such redux dependency issue
        if (this.props.isRightDataType != null && this.props.isRightDataType !== undefined && !this.props.isRightDataType) return;
        //this.props.editMetadata(); //reset error msg TODO: Need to solve such redux dependency issue
        if (this.props.isRightDataType != null && this.props.isRightDataType !== undefined && !this.props.isRightDataType) {
            return;
        } else {
            this.props.onToggle(Math.abs(this.props.id));
            this.setState({ target: e.currentTarget });
            return;
        }
    }

    renderEditorToggle(buttonType, buttonInner, className, editorToggleAction) {
        switch (buttonType) {
            case IButtonType.BootstrapButton:
                return (
                    <Button
                        key={`addRowEditor_button${this.props.id}`}
                        className={className}
                        variant="dark"
                        onClick={editorToggleAction}>
                        {typeof buttonInner !== "string" ?
                            <FontAwesomeIcon icon={buttonInner} /> : buttonInner
                        }
                    </Button>
                )
            case IButtonType.faEditorToggler:
                return (
                    <div
                        key={`addRowEditor_button_div${this.props.id}`}
                        className={className}
                        onClick={editorToggleAction}>
                        {this.props.isActive ?

                            <FontAwesomeIcon icon={faTimesCircle}></FontAwesomeIcon>
                            : <FontAwesomeIcon icon={this.props.toggleIcon}></FontAwesomeIcon>}
                    </div>
                )
            case IButtonType.faToggleIconProp:
                return (
                    <FontAwesomeIcon
                        className={className}
                        icon={this.props.toggleIcon}
                        onClick={editorToggleAction}></FontAwesomeIcon>
                )
        }
    }

    onEditorSubmit = () => {
        var fieldVal =
            !!this.props.mediaEditInfo[0].dropdownValKey && !!this.state.fieldVals[0][this.props.mediaEditInfo[0].dropdownValKey] ?
                this.state.fieldVals[0][this.props.mediaEditInfo[0].dropdownValKey] :
                this.state.fieldVals[0]

        // right now can only submit 1 value 
        if (this.props.mediaEditInfo[0].type === EditorConstant.DataEditorType.DATE_TIME_FIELD)
            fieldVal = Utilitis.formatObjectDate((fieldVal).toString(), UtilConstant.HUB_TIME_FORMAT.ROBOTIC, true, true, false)
        //check for data duplicate if necessary
        if (this.props.foundDuplicatedData !== undefined) {
            if (this.props.foundDuplicatedData(this.props.id, fieldVal)) {
                this.props.onSubmit(!!this.props.isAddRow ? -1 : this.props.id, fieldVal);
                this.props.onToggle(this.props.id);
                this.initializeFieldVals();
            }
        }
        else {
            this.props.onSubmit(!!this.props.isAddRow ? -1 : this.props.id, fieldVal);
            this.props.onToggle(this.props.id);
            this.initializeFieldVals();
        }
    }

    isValidURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }

    renderEditorContent(isPopupEnabled) {
        return (
            <div key={`editorContent${this.props.id}`}>
                {this.renderFields()}
                {
                    isPopupEnabled ?
                        this.renderEditorToggle(
                            IButtonType.BootstrapButton,
                            (this.props.mediaEditInfo[0].validateType === EditorConstant.DataValidationType.URL && !this.isValidURL(this.state.fieldVals[0].toString())) ?
                                "Invalid URL" : "Confirm",
                            `rowEditorButton ${(!(!!this.state.fieldVals[0])
                                || (this.props.mediaEditInfo[0].validateType === EditorConstant.DataValidationType.URL && !this.isValidURL(this.state.fieldVals[0].toString())))
                                ? "disabled" : ""
                            }`,
                            this.onEditorSubmit)
                        :
                        <OverlayTrigger
                            key={`addRowEditor_OverlayTrigger${this.props.id}`}
                            placement={this.props.placement ? this.props.placement : "bottom"}
                            overlay={<Tooltip id={`${this.props.id}`} className="rowActionTooltip"
                                style={{ paddingLeft: "20px" }}>{this.renderTooltipText()}</Tooltip>}>
                            {this.renderEditorToggle(
                                IButtonType.faToggleIconProp,
                                this.props.toggleIcon,
                                //this.props.isRightDataType != null && this.props.isRightDataType !== undefined && !this.props.isRightDataType ? "disabled" : "",
                                this.props.mediaEditInfo[0].validateType === EditorConstant.DataValidationType.URL && !this.isValidURL(this.state.fieldVals[0].toString()) ? "disabled" : "",
                                this.props.mediaEditInfo[0].validateType === EditorConstant.DataValidationType.URL && !this.isValidURL(this.state.fieldVals[0].toString()) ? () => { } : this.onEditorSubmit)}
                        </OverlayTrigger>
                }
            </div>
        )
    }

    renderEditorOverlay(isPopupEnabled) {
        if (isPopupEnabled) {
            return (
                <Overlay
                    show={this.props.isActive}
                    key='bottom'
                    placement={!!this.props.placement ? this.props.placement : "bottom"}
                    container={this.overlayRef}
                    target={this.state.target}
                    popperConfig={{
                        modifiers: [
                            { name: "preventOverflow", enabled: false },
                            { name: "offset", enabled: true }
                        ]
                    }}
                >
                    <Popover
                        className="rowEditor addRowEditor"
                        id={`popover`}
                        key="popover">
                        <Popover.Title className="rowEditorTitle" as="h3">
                            {this.props.title}
                        </Popover.Title>
                        <Popover.Content className="rowEditorContent">
                            {this.renderEditorContent(isPopupEnabled)}
                        </Popover.Content>
                    </Popover>
                </Overlay>
            )
        } else {
            return this.renderEditorContent(isPopupEnabled)
        }
    }

    render() {
        if (!this.areDataEditorPropsFullyInitialized()) return <div><b>Missing DataEditor Props.  Please check the console for more info.</b></div>;

        return (
            <div key="dataEditor" className={`editRow ${this.props.disablePopup ? "disablePopup" : ""}`}>
                {
                    this.props.disablePopup ?
                        <div key="addDataEditor" className="editRowWrapper" ref={this.overlayRef}>
                            {this.renderEditorOverlay(!this.props.disablePopup)}
                        </div>
                        :
                        <OverlayTrigger
                            key="addDataEditor"
                            placement={this.props.placement ? this.props.placement : "bottom"}
                            overlay={<Tooltip id={`${this.props.id}`} className="rowActionTooltip"
                                style={{ paddingLeft: "20px" }}>{this.renderTooltipText()}</Tooltip>}>
                            <div key="addDataEditor_div" className="editRowWrapper" ref={this.overlayRef}>
                                {this.renderEditorToggle(
                                    this.props.isAddRow ? IButtonType.BootstrapButton : IButtonType.faEditorToggler,
                                    this.props.isAddRow ? faPlus : this.props.toggleIcon,
                                    `${this.props.isRightDataType != null && this.props.isRightDataType !== undefined && !this.props.isRightDataType ? "disabled disabledWithTooltip" : ""
                                    } ${this.props.isAddRow ? "addButton" : ""
                                    }`,
                                    this.onClickEditorToggle
                                )}
                                {this.renderEditorOverlay(!this.props.disablePopup)}
                            </div>
                        </OverlayTrigger>
                }
            </div>
        )
    }
}